module.exports = __webpack_public_path__ + "img/50.1d522ce7.jpg";